import React from 'react';

export default ({ children }) => <span className="font-normal text-primary text-2xl md:text-5xl uppercase ml-8">{children}</span>;
